import { fetchForms } from './fetch-forms';
import { loadLocaleDataset, loadTranslations, } from '../../services/load-translations';
import { fetchAddressForms } from '../../services/fetch-address-forms';
import { hasMultilineAddress } from '../../services/has-multiline-address';
export const getInitialData = async ({ formIds, formKind, namespace, throwWhenFormMissing, locale, httpClient, errorMonitor, isMultilineAddressInTemplatesEnabled, }) => {
    const [formsById, translations, tpaTranslations, localeDataset] = await Promise.all([
        fetchForms({
            formIds,
            formKind,
            namespace,
            httpClient,
            errorMonitor,
            throwWhenFormMissing,
        }),
        loadTranslations(locale),
        {}, // loadTPATranslations(locale),
        loadLocaleDataset(locale),
    ]);
    let addressTemplates;
    if (isMultilineAddressInTemplatesEnabled &&
        Object.values(formsById).some((form) => hasMultilineAddress(form))) {
        addressTemplates = await fetchAddressForms(httpClient);
    }
    return {
        formsById,
        translations,
        tpaTranslations,
        localeDataset,
        addressTemplates,
    };
};
//# sourceMappingURL=get-initial-data.js.map